/* esm.sh - zod@4.4.3/v4/locales/en */
export * from "/*zod@4.4.3/esnext/v4/locales/en.mjs";
export { default } from "/*zod@4.4.3/esnext/v4/locales/en.mjs";
